import { render, staticRenderFns } from "./element-select-list-wrap-for-item.vue?vue&type=template&id=1624f428&scoped=true"
import script from "./element-select-list-wrap-for-item.vue?vue&type=script&lang=js"
export * from "./element-select-list-wrap-for-item.vue?vue&type=script&lang=js"
import style0 from "./element-select-list-wrap-for-item.vue?vue&type=style&index=0&id=1624f428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1624f428",
  null
  
)

export default component.exports